/*
 * Copyright Evollis 2021
 * All Rights Reserved.
 *
 * All information contained herein is, and remains the property of Evollis.
 * The intellectual and technical concepts contained herein are
 * proprietary to Evollis and are protected by trade secret and copyright law.
 * Dissemination of this information or reproduction of this material
 * is STRICTLY FORBIDDEN unless prior written permission is obtained
 * from Evollis.
 */
import { AccessKeysContext } from "../context/AccessKeysContext"
import React, { Component } from "react"
import { Col, Form, FormGroup } from "react-bootstrap"
import { Field as FinalFormField } from "react-final-form"
import ReactPhoneInput from "react-phone-input-2"
import "react-phone-input-2/lib/style.css"

export default class NumberFieldPhone extends Component {
  render() {
    return (
      <AccessKeysContext.Consumer>
        {(accessKeys = {}) => {
          const { name, countryCode } = this.props
          const ak = accessKeys[name] || {}
          const {
            hidden,
            placeholder,
            label,
            className,
            xs,
            lg,
            xl,
            md,
            sm,
            xsHidden,
            smHidden,
            mdHidden,
            lgHidden,
            xlHidden,
            disabled,
            hasServerErrors,
            noFormGroup,
            formGroupProps,
            initialValue,
            type = "number",
            children
          } = { ...this.props, ...ak }

          const countryCodeEditable = !(
            countryCode === "IT" ||
            countryCode === "ES" ||
            countryCode === "NL" ||
            countryCode === "BE"
          )

          return (
            !hidden && (
              <FinalFormField
                name={name}
                component="input"
                type={type}
                placeholder={placeholder}
                className="form-control"
                initialValue={initialValue}
              >
                {({ input, meta }) => {
                  const metaError = meta.error && (meta.touched || hasServerErrors)
                  const hasError = metaError || meta.submitError
                  const cl = {
                    "d-none": xsHidden || smHidden || mdHidden || lgHidden || xlHidden,
                    "d-sm-block": !smHidden,
                    "d-sm-none": smHidden,
                    "d-md-block": !mdHidden,
                    "d-md-none": mdHidden,
                    "d-lg-block": !lgHidden,
                    "d-lg-none": lgHidden,
                    "d-xl-block": !xlHidden,
                    "d-xl-none": xlHidden,
                    "col-no-padding": true
                  }
                  if (className) {
                    cl[className] = true
                  }
                  const hasColParam =
                    xs || lg || xl || md || sm || xsHidden || smHidden || mdHidden || lgHidden || xlHidden
                  const colParams = { className: cl, xs, lg, xl, md, sm }

                  let body = [
                    <div className="d-flex" key={label}>
                      {label && <Form.Label>{label}</Form.Label>}
                      {children}
                    </div>,
                    <ReactPhoneInput
                      key={name + label}
                      {...input}
                      inputProps={{
                        id: name
                      }}
                      className={`${hasError ? "textfield-error" : ""}`}
                      type="text"
                      placeholder={placeholder}
                      disabled={disabled}
                      onlyCountries={[countryCode.toLowerCase()]}
                      country={countryCode.toLowerCase()}
                      {...{ countryCodeEditable }}
                      disableDropdown
                    />,
                    <React.Fragment key={"alert" + label}>
                      {hasError && <p className="required-message">{meta.error || meta.submitError}</p>}
                    </React.Fragment>
                  ]
                  if (!noFormGroup) {
                    body = <FormGroup {...formGroupProps}>{body}</FormGroup>
                  }

                  if (hasColParam) {
                    body = <Col {...colParams}>{body}</Col>
                  }

                  return body
                }}
              </FinalFormField>
            )
          )
        }}
      </AccessKeysContext.Consumer>
    )
  }
}
